// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Error when sending message failed
 */
export class SendMessageError extends Error {
    /**
     * Initialize a SendMessageError
     * @param message - The error message
     * @param ackMessage - The ack message
     */
    constructor(message, options) {
        super(message);
        this.name = "SendMessageError";
        this.ackId = options.ackId;
        this.errorDetail = options.errorDetail;
    }
}
//# sourceMappingURL=index.js.map